import React, {createContext, useContext, useEffect, useState} from "react";

interface DeviceContextType {
  isMobile: boolean;
}

const DeviceContext = createContext<DeviceContextType>({isMobile: false});

export const DeviceProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    // Початкове значення
    setIsMobile(mediaQuery.matches);

    // Слухаємо зміни
    const handler = (e: MediaQueryListEvent | MediaQueryList) => {
      setIsMobile(e.matches);
    };

    // Для нових браузерів
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handler);
    }
    // Для старих Safari
    else {
      mediaQuery.addListener(handler);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handler);
      } else {
        mediaQuery.removeListener(handler);
      }
    };
  }, []);

  return (
    <DeviceContext.Provider value={{isMobile}}>
      {children}
    </DeviceContext.Provider>
  );
};

export const useDevice = () => useContext(DeviceContext);
